<template>
  <a-layout
    :style="{ height: '100vh' }"
    class="home-wrapper"
  >
    <a-layout-sider
      breakpoint="lg"
      collapsed-width="0"
    >
      <div class="logo" />
      <a-menu
        theme="dark"
        mode="inline"
        :default-selected-keys="[matchPath]"
        :open-keys="openKeys"
        @openChange="onOpenChange"
        @click="handleClick"
      >
        <a-sub-menu
          v-for="item in menuData"
          :key="item.id"
        >
          <span slot="title">
            <a-icon :type="item.icon" />
            {{ item.menuName }}
          </span>
          <a-menu-item
            v-for="item1 in item.children"
            :key="item1.path"
          >
            {{ item1.menuName }}
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>
    <a-layout
      id="layoutContent"
      :style="{position: 'relative'}"
    >
      <a-layout-header :style="{ background: '#fff', paddingRight: '38px' }">
        <div :style="{ textAlign: 'right' }">
          <div
            :style="{
              marginLeft: '38px',
              fontSize: '16px',
              display: 'inline-block',
            }"
          >
            欢迎你，{{ userName }}
            <a-dropdown>
              <icon-font type="iconoperation" />
              <a-menu slot="overlay">
                <!-- <a-menu-item>
                  <router-link to="/business">设置账号</router-link>
                </a-menu-item> -->
                <a-menu-item>
                  <a @click="handleLogout">退出账号</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
      </a-layout-header>
      <a-layout-content :style="{ margin: '0 38px 0' }">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { menuData } from './data/index';
export default {
  data() {
    return {
      menuData,
      userName: '',
      openKeys: [],
    };
  },
  computed: {
    matchPath() {
      const path = this.$route.path;
      const matchPath = path.split('/')[1];
      return `/${matchPath}`;
    },
  },
  async mounted() {
    // 用户名
    this.userName = localStorage.getItem('userName');
    // 获取菜单key
    const mathMenu = this.menuData.find((item) =>
      item.children.some((c) => c.path === this.matchPath),
    );
    if (mathMenu) {
      this.openKeys = [mathMenu.id];
    }
  },
  methods: {
    onOpenChange(openKeys) {
      this.openKeys = openKeys.slice(-1);
    },
    handleClick(e) {
      this.$router.push(e.key);
    },
    // 退出登录
    handleLogout() {
      localStorage.clear();
      this.$router.replace('/login');
    },
    // 点击菜单
    handleMenu(e) {
      this.$router.push(e.key);
      sessionStorage.setItem('menukey', e.key);
    },
  },
};
</script>

<style lang="scss">
.home-wrapper {
  .logo {
    height: 40px;
    margin: 16px;
    background: url('../assets/logo.png');
    background-size: 100% 100%;
  }
}
</style>
